import { registerBrick, VisualBrick, QueryResult, BrickContext } from 'olympe';
import { combineLatest, map, tap } from 'rxjs';
import {
    getChartHeight,
    buildComponentChartDatasets,
    getComponentDefectChartRawData
} from '../utils/function/defectChartData';

import {Chart, BarElement, Tooltip, Legend, BarController, CategoryScale, LinearScale} from "chart.js";
// Need to register them for tree shaking
Chart.register(BarElement, Tooltip, Legend, BarController, CategoryScale, LinearScale);

export default class ComponentDefectChart extends VisualBrick {
    /**
     * @override
     */
    setupExecution($) {
        return combineLatest([$.observe('Component'), $.observe('Unit')]).pipe(
            map(([component, unit]) => getComponentDefectChartRawData(component, unit))
        );
    }

    /**
     * @override
     */
    updateParent(parent, element) {
        parent.style.overflow = 'auto';
        return super.updateParent(parent, element);
    }

    /**
     * @override
     * @param {!BrickContext} $
     * @param {QueryResult<Inspection, Observation>} inspectionsWithObservation
     * @param {QueryResult<Aspect>} aspects
     * @param {Map<number, number>} inspectionResultMapping
     */
    render($, [inspectionsWithObservation, aspects, inspectionResultMapping]) {
        const container = document.createElement('div');
        container.style.width = '100%';

        const canvas = document.createElement('canvas');
        container.appendChild(canvas);

        const chart = ComponentDefectChart.createChart(canvas, {}, false);

        $.observe('graph result').pipe(tap((graphResult) => {
            const data = buildComponentChartDatasets(graphResult, inspectionsWithObservation, aspects, inspectionResultMapping);
            container.style.height = `${getChartHeight(data)}px`;
            chart.data = data;
            chart.update();
        })).subscribe();

        return container;
    }

    /**
     * @param {HTMLCanvasElement} canvas
     * @param {{data, labels}} data
     * @param {boolean} isStatic
     * @return {Chart}
     */
    static createChart(canvas, data, isStatic) {
        return new Chart(canvas, {
            type: 'bar',
            data: data,
            options: {
                indexAxis: 'y',
                responsive: !isStatic,
                maintainAspectRatio: false,
                animation: false,
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Defect [%]',
                            font: { size: 12, weight: 'bold',},
                        },
                        max: 100,
                    },
                },
            }
        });
    }
}

registerBrick('018a114a1eaa8a114fac', ComponentDefectChart);
